import { FC } from "react"
import "./RSVPPartnerNetworkPage.scss"

import DefaultLayout from "src/layouts"
import BannerImageSection from "src/sections/RSVPPartnerNetworkSections/BannerImageSection"
import { BenefitsPartnersSection } from "src/sections/RSVPPartnerNetworkSections/BenefitsPartnersSection/BenefitsPartnersSection"
import HeroSection from "src/sections/RSVPPartnerNetworkSections/HeroSection"
import PartnershipExpectationsSection from "src/sections/RSVPPartnerNetworkSections/PartnershipExpectationsSection"

const RSVPPartnerNetworkPage: FC = () => {
  return (
    <DefaultLayout isFooterAnimated={false}>
      <main className='main rsvp-partner-network-page'>
        <HeroSection />
        <BenefitsPartnersSection />
        <BannerImageSection />
        <PartnershipExpectationsSection />
      </main>
    </DefaultLayout>
  )
}

export default RSVPPartnerNetworkPage
